import { Component, ChangeDetectionStrategy} from '@angular/core';
import { MmtCommonService } from '../../../services/mmt-common.service';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
  selector: 'app-custom-mrn',
  templateUrl: './custom-mrn.component.html',
  styleUrls: ['./custom-mrn.component.scss']
})
export class CustomMrnComponent implements ICellRendererAngularComp {

  mrnModelValue: any;
  mrnModifiedValue: any;
  isMRNUnmasked: boolean = false;
  intervalMRN: any;
  timerLeft: number = 5;
  isMRNAvailable: boolean;
  isMRNEdited: boolean;
  params: any;
  uniqueRowID: any;

  constructor(
    private mmtCommonService: MmtCommonService
  ) { }

  agInit(params): void {
    this.params = params;
    if (params.mrnValue) {
      this.isMRNAvailable = true;
      this.mrnModifiedValue = params.mrnValue;
      if (this.mrnModifiedValue.indexOf('(Missing Required Data)') > -1 || this.mrnModifiedValue.toString().indexOf('Data Error') > -1) {
        this.mrnModelValue = this.mrnModifiedValue;
        this.isMRNAvailable = false;
      }
      else {
        this.mrnModelValue = this.mmtCommonService.getMasked(params.mrnValue, 3, 3);
      }
      if (params.source !== 'patientGrid') {
        this.uniqueRowID = params.importHeaderId;
      }
    }
  }

  updateMRN(editedValue) {
    if (!editedValue) {
      this.isMRNAvailable = false;
      this.mrnModifiedValue = editedValue;
    }
    if (editedValue && this.isMRNEdited) {
      this.mrnModelValue = editedValue;
      this.mrnModifiedValue = this.mrnModelValue;
      this.mrnModelValue = this.mmtCommonService.getMasked(this.mrnModelValue, 3, 3);
      if(this.params.column.colId === 'mrn'){
        this.params.data.mrn = this.mrnModifiedValue;
      }else if(this.params.column.colId === 'pin'){
        this.params.data.pin = this.mrnModifiedValue;
      }
      this.isMRNEdited = false;
      this.isMRNAvailable = true;
      this.invokeCustomRefresh(this.params.column.colId);

    }
    if (editedValue === '' && this.isMRNEdited) {
      if(this.params.column.colId === 'mrn'){
        this.params.data.mrn = this.mrnModifiedValue;
      }else if(this.params.column.colId === 'pin'){
        this.params.data.pin = this.mrnModifiedValue;
      }
      this.invokeCustomRefresh(this.params.column.colId);
    }
  }

  private invokeCustomRefresh(colId: any): void {
    const parent = this.params && this.params.context && this.params.context.componentParent;
    if (parent && typeof parent.customRefresh === 'function') {
      parent.customRefresh(colId);
    }
  }

  viewMRN() {
    this.mrnModelValue = this.mrnModifiedValue;
    this.isMRNUnmasked = true;
    clearInterval(this.intervalMRN);
    this.timerLeft = 5;
    this.isMRNAvailable = false;
    this.intervalMRN = setInterval(() => {
      if (this.timerLeft > 0) {
        this.timerLeft--;
      } else {
        this.timerLeft = 5;
        clearInterval(this.intervalMRN);
        this.mrnModelValue = this.mmtCommonService.getMasked(this.mrnModelValue, 3, 3);;
        this.isMRNUnmasked = false;
        this.isMRNAvailable = true;
      }
    }, 1000)
    if(this.params.column.colId === 'mrn'){
      if (this.params.source === 'patientGrid'){
        this.mmtCommonService.insertAuditLog("User viewed MRN", "Patient Data grid screen for Encounter ID " + this.params.data.encounterId + ".");
      }
      else {
        this.mmtCommonService.insertAuditLog("User viewed MRN", "Review section of Import Patient Data screen for Cost Center " + this.params.data.costCenter + ",ImportHeader Id " + this.uniqueRowID + " and importDetail Id " + this.params.data.id + ".");
      }
    }else if(this.params.column.colId === 'pin'){
      if (this.params.source === 'patientGrid') {
        this.mmtCommonService.insertAuditLog("User viewed PIN", "Patient Data grid screen for Encounter ID " + this.params.data.encounterId + ".");
      }
      else {
        this.mmtCommonService.insertAuditLog("User viewed PIN", "Review section of Import Patient Data screen for Cost Center " + this.params.data.costCenter + ",ImportHeader Id " + this.uniqueRowID + " and importDetail Id " + this.params.data.id + ".");
      }
    }
    
  }

  clearMRN() {
    if (this.mrnModifiedValue && this.mrnModifiedValue.toString().trim() === '(Missing Required Data)') {
      this.mrnModifiedValue = '';
      this.mrnModelValue = '';
      this.isMRNAvailable = false;
    }
  }

  editMRN(event) {
    if (!(/^\d*[a-zA-Z]*$/.test(event.key))) {
      event.preventDefault();
    } else if (((event.which == 8) || (event.which >= 48 && event.which <= 57) || (event.which >= 65 && event.which <= 90) || (event.which >= 96 && event.which <= 105))) {

      if (this.mrnModifiedValue && !this.isMRNEdited) {
        this.mrnModelValue = this.mrnModifiedValue;
        clearInterval(this.intervalMRN);
        this.isMRNUnmasked = false;
        this.timerLeft = 5;
      }
      this.isMRNEdited = true;
    }
  }

  refresh(): boolean {
    return true;
  }
}
